(function () {
  'use strict';
  var L = window.MarmotMotoveLogic;
  if (!L) return;
  if (!document.querySelector('[data-marmot-campaign]')) return;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-marmot-campaign]'));
  }

  function removeExpired(now) {
    var alive = false;
    roots().forEach(function (node) {
      var end = Number(node.dataset.endMs);
      if (!Number.isFinite(end) || now >= end) node.remove();
      else alive = true;
    });
    if (!alive) document.body.classList.remove('marmot-donation-active');
    return alive;
  }

  function updateCountdowns(now) {
    document.querySelectorAll('[data-marmot-countdown]').forEach(function (node) {
      var value = L.countdown(Number(node.dataset.endMs), now);
      if (value.expired) { node.remove(); return; }
      node.querySelector('[data-marmot-days]').textContent = value.days;
      node.querySelector('[data-marmot-hours]').textContent = value.hours;
      node.querySelector('[data-marmot-minutes]').textContent = value.minutes;
    });
  }

  // Лентата е fixed; хедърът и празнината под нея стоят на --marmot-donation-bar-h. CSS дава
  // разумна стойност (46/78 px), но текстът може да е по-дълъг (сумата, „Виж защо“, по-тесен
  // екран) – тогава лентата би легнала върху хедъра. Затова височината се мери.
  function fitBar() {
    var bar = document.querySelector('.marmot-donation-top');
    if (!bar || !document.body.classList.contains('marmot-donation-active')) return;
    document.body.style.setProperty('--marmot-donation-bar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px', 'important');
  }

  var now = Date.now();
  if (!removeExpired(now)) return;
  fitBar();
  window.addEventListener('resize', fitBar);
  updateCountdowns(now);
  window.setInterval(function () {
    var tick = Date.now();
    if (removeExpired(tick)) updateCountdowns(tick);
  }, 60000);

  var source = document.querySelector('[data-marmot-campaign-source]');
  if (!source || !source.dataset.amountUrl) return;
  L.fetchAmount(source.dataset.amountUrl, Number(source.dataset.amountThreshold), window.fetch.bind(window), 2500)
    .then(function (amount) {
      if (amount === null) return;
      var formatted = new Intl.NumberFormat('bg-BG', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount);
      document.querySelectorAll('[data-marmot-amount-host]').forEach(function (host) {
        if (host.querySelector('[data-marmot-donation-amount]')) return;
        var node = document.createElement('p');
        var value = document.createElement('strong');
        node.className = 'marmot-donation-amount';
        node.dataset.marmotDonationAmount = '';
        node.appendChild(document.createTextNode(source.dataset.amountLabel + ' '));
        value.textContent = formatted;
        node.appendChild(value);
        node.appendChild(document.createTextNode('\u00a0€'));
        host.appendChild(node);
      });
      fitBar();
    });
})();
